
import { defineComponent, PropType } from 'vue'
import { IOrderElement } from '@entities/order/model/types'
import { useThemeModel } from '@entities/theme'
import { useOrderModel } from '@entities/order'
import { useMetaModel } from '@entities/meta'

interface IPropData extends IOrderElement {
  diffCheck: boolean
}

export default defineComponent({
  name: 'OrderItem',
  props: {
    data: {
      type: Object as PropType<IPropData>,
      required: true,
      default: () => ({
        price: 10000,
        name: 'Суп',
        diffCheck: false,
        modifiers: [
          {
            name: 'Модификатор'
          }
        ]
      })
    },
    currencyIcon: {
      type: String as PropType<string>,
      required: false,
      default: ''
    },
    enableCheckbox: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    showStatus: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: true
    }
  },
  emits: ['checkPosition'],

  setup () {
    const themeModel = useThemeModel()
    const orderModel = useOrderModel()
    const metaModel = useMetaModel()
    return {
      themeModel,
      orderModel,
      metaModel
    }
  },

  computed: {
    hasDifferentPrice (): boolean {
      return this.data.finalPrice !== this.data.price
    },

    statusOrderItem (): string {
      if (this.data.status === 'PAID') {
        return 'payed'
      }
      if (this.data.loading) {
        return 'loading'
      }
      if (this.data.selected_guest_id === this.metaModel.guest) {
        return 'not pay'
      }
      if (this.data.selected_guest_id && this.data.status === 'NOT_PAID') {
        return 'paying'
      }
      return 'not pay'
    },
    paymentCheck (): boolean {
      if (this.data.selected_guest_id) {
        return this.data.selected_guest_id !== this.metaModel.guest
      }
      return false
    }
  },
  methods: {
    async checkPosition (): Promise<void> {
      if (!this.data.diffCheck || this.statusOrderItem === 'payed') {
        return
      }
      if (!this.paymentCheck && this.statusOrderItem !== 'loading') {
        this.orderModel.loadingOrderElement(this.data.id)
        const guest = await sessionStorage.getItem('guest')
        this.$emit('checkPosition', {
          id: this.data.id.toString(),
          status: this.data.selected_guest_id === this.metaModel.guest,
          guest: guest ? parseInt(guest) : null
        })
      }
    }
  }
})
